import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactSimpleModal from 'shared/design-system/components/TrueImpactSimpleModal';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrakeWarning } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface AllocationWarningProps {
  open: boolean;
  totalReportBudget: number;
  totalAllocationAmount: number;
  handleClose: () => unknown;
}

const StyledDiv = styled.div`
  max-width: 500px;
  padding: ${SPACERS.large};
  .mt-2 {
    margin-top: ${SPACERS.medium};
  }
  .icon-container {
    text-align: center;
    margin-bottom: ${SPACERS.small};
  }
`;

const AllocationWarning: React.FC<AllocationWarningProps> = ({
  open,
  totalReportBudget,
  totalAllocationAmount,
  handleClose,
}) => {
  const amount = totalAllocationAmount - totalReportBudget;
  return (
    <TrueImpactSimpleModal
      next={{
        text: 'Ok',
        onClick: handleClose,
      }}
      open={open}
      onClose={handleClose}
    >
      <StyledDiv>
        <div className="icon-container">
          <FontAwesomeIcon
            size="3x"
            className="icon"
            icon={faBrakeWarning}
            color={COLORS.ctaPrimary}
          />
        </div>
        <TrueImpactText>
          Your reported program budget is currently lower than the sum of the
          donations allocated to this report by{' '}
          <strong>${numberWithCommas(amount)}</strong>.
        </TrueImpactText>
        <TrueImpactText className="mt-2">
          Please make adjustments to your budget on this page in order to
          continue.
        </TrueImpactText>
      </StyledDiv>
    </TrueImpactSimpleModal>
  );
};

export default AllocationWarning;
